module.exports = __webpack_public_path__ + "img/shopmania_icon.8e560685.png";